<app-data-room pageTitle="Company Data" [documentTypes]="docTypes" [objectId]="objectId"></app-data-room>
